// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"856563d4","453":"edbd3e71"}[chunkId] + ".chunk.js";
};